import _extends from "@babel/runtime/helpers/extends";
import classNames from 'classnames';
import React from 'react';
import { TextFieldTheme, TextField as TPATextField } from '@wix/wix-ui-tpa/cssVars';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
import { useTranslation } from '../../../contexts/translation-context';
import { classes } from './day-field-wut.st.css';
export function DayFieldWUT(props) {
  const {
    id,
    className,
    onChange,
    ...rest
  } = props;
  const {
    t
  } = useTranslation();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  return /*#__PURE__*/React.createElement(TPATextField, _extends({}, rest, {
    type: "text",
    inputMode: "numeric",
    maxLength: 2,
    theme: TextFieldTheme.Box,
    newErrorMessage: true,
    onChange: handleChange,
    "aria-label": t('field.date.placeholder.day'),
    className: classNames(className, classes.root, classes.theme, {
      [classes.hover]: forcedHover
    })
  }));
  function handleChange(event) {
    props.onChange == null || props.onChange(event.target.value);
  }
}
//# sourceMappingURL=day-field-wut.js.map